import { render, staticRenderFns } from "./TableForm5.vue?vue&type=template&id=2171b3ee&scoped=true"
import script from "./TableForm5.vue?vue&type=script&lang=ts"
export * from "./TableForm5.vue?vue&type=script&lang=ts"
import style0 from "./TableForm5.vue?vue&type=style&index=0&id=2171b3ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2171b3ee",
  null
  
)

export default component.exports